// actions.js
import * as types from "../../actionTypes";

export const fetchCitiesRequest = (keyword) => ({
  type: types.FETCH_CITIES_REQUEST,
  payload: keyword ,
});

export const fetchCitiesSuccess = (data) => ({
  type: types.FETCH_CITIES_SUCCESS,
  payload: data ,
});

export const fetchCitiesFailure = (error) => ({
  type: types.FETCH_CITIES_FAILURE,
  payload:  error ,
});

